module.exports = __webpack_public_path__ + "static/img/Encounter.b606d7d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Encounter.jpeg
// module id = dzF7
// module chunks = 7